<template>
  <div>
    <div class="trustAdvisor-title">
      <div>Advisor</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="['monitor:trustAdvisor:add_alert_rule']"
          @click="addOrUpdateHandle"
          >{{ $t("TrustAdvisor.addTrustAdvisorAlert") }}</Button
        >
        <add-or-update-trust-advisor-warning
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
        ></add-or-update-trust-advisor-warning>
      </div>
    </div>
    <template>
      <Tabs size="small" :animated="false">
        <TabPane :label="$t('alarms.common.alertRule')">
          <div class="trustAdvisor-top">
            <trust-advisor-warning-search></trust-advisor-warning-search>
          </div>
          <table-trust-advisor-warning></table-trust-advisor-warning>
        </TabPane>
        <!-- 很多用户没有"business support" 所以暂时关闭该概览页面(sme-835) -->
        <!--  <TabPane label="概览">
                    <trust-advisor-list></trust-advisor-list>
                </TabPane> -->
      </Tabs>
    </template>
  </div>
</template>

<script>
import TrustAdvisorList from "../trustAdvisor/trustAdvisor_list/TrustAdvisorList";
import TrustAdvisorWarningSearch from "../trustAdvisor/trustAdvisor_monitor/TrustAdvisorWarningSearch";
import TableTrustAdvisorWarning from "../trustAdvisor/trustAdvisor_monitor/TableTrustAdvisorWarning";
import AddOrUpdateTrustAdvisorWarning from "../trustAdvisor/trustAdvisor_monitor/AddOrUpdateTrustAdvisorWarning";

export default {
  name: "TrustAdvisor",
  components: {
    TrustAdvisorList,
    TrustAdvisorWarningSearch,
    TableTrustAdvisorWarning,
    AddOrUpdateTrustAdvisorWarning
  },
  data() {
    return {
      addOrUpdateVisible: false
    };
  },
  methods: {
    // 添加报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    }
  }
};
</script>

<style scoped>
.trustAdvisor-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.trustAdvisor-title > div:nth-child(1) {
  float: left;
}
.trustAdvisor-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.trustAdvisor-top {
  width: 100%;
  height: 32px;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/trustAdvisor/TrustAdvisor.vue